import React, { useEffect, useRef, useState } from "react";
import CompanyLogo from "../../common/CompanyLogo";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import youtube_play from "../../assets/youtube_play.png";
import Api_Instance from "../../api/Api_Instance";
import { CATEGORY, VideoEndpoints } from "../../api/endpoints";

const Video = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [singleVideo, setSingleVideo] = useState();
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const videoRef = useRef(null);

  const api = Api_Instance.unAuth();

  const handleClose = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.pause();
    }
    setShowVideoPlayer(false);
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const getVideos = async (pageNumber, category = null) => {
    setIsLoading(true);
    try {
      const url = `${VideoEndpoints?.GET_VIDEO_API}?page_size=5&page=${pageNumber > 0 ? pageNumber : 1}${category ? `&category=${category}` : ""
        }`;
      const response = await api("GET", url);
      const newVideos = response?.data?.data || [];
      setHasMore(newVideos.length == 5);
      if (newVideos.length > 0) {
        // Add new videos only if they are not already in the list
        setFilteredVideos((prev) => {
          const existingIds = new Set(prev.map((video) => video.id));
          const uniqueVideos = newVideos.filter((video) => !existingIds.has(video.id));
          return [...prev, ...uniqueVideos];
        });

      } else {
        // setHasMore(false);
      }
    } catch (error) {


    } finally {
      setIsLoading(false);
    }
  };
  const getCategoryVideos = async (pageNumber, category = null) => {
    setIsLoading(true);
    try {
      const url = `${VideoEndpoints?.GET_VIDEO_API}?page_size=5&page=${pageNumber > 0 ? pageNumber : 1}&category_name=${category}`
      const response = await api("GET", url);
      const newVideos = response?.data?.data || [];
      if (newVideos.length > 0) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
      if (newVideos.length) {
        setFilteredVideos((prev) => [...prev, ...newVideos]);
      } else {
        // setHasMore(false);
      }
    } catch (error) {
      if (error?.response.data?.detail) {
        setHasMore(false);
      }

    } finally {
      setIsLoading(false);
    }
  };
  const getCategories = async () => {
    try {
      const response = await api("GET", CATEGORY.GET_CATEGORY);
      setCategoryData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getVideos(page);
    getCategories();
  }, []);

  useEffect(() => {
    // Reset page and videos when category changes
    setFilteredVideos([]);
    setPage(1);
    getCategoryVideos(1, selectedCategory);
  }, [selectedCategory]);

  const getVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|\/u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const loadMoreVideos = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    if (selectedCategory) {
      getCategoryVideos(nextPage, selectedCategory);
    } else {
      getVideos(nextPage, selectedCategory);
    }
  };

  return (
    <>
      <CompanyLogo title={"Videos"} subtitle={"Videos"} />
      <div className="w-full max-w-[1250px]      mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
        <div className="flex justify-between items-center gap-2">
          <h1 className="text-3xl font-semibold text-text_color p-2 mt-4">
            {selectedCategory || "All Categories"}
          </h1>
          <div>
            <div className="mx-auto flex justify-end items-end">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <MenuButton className="inline-flex w-full justify-center border gap-x-4 rounded-md bg-[#F5F5F5] px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                    {selectedCategory || "Business Categories"}
                    <ChevronDownIcon
                      className="-mr-1 h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </MenuButton>
                </div>
                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                >
                  <div className={classNames(
                    "py-1",
                    categoryData?.length > 10 ? "overflow-auto max-h-80" : ""
                  )}>
                    {categoryData?.map((item, index) => (
                      <MenuItem key={index}>
                        {({ active }) => (
                          <a
                            onClick={() => setSelectedCategory(item.name)}
                            className={classNames(
                              active
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-700",
                              "block px-4 py-2 text-sm cursor-pointer "
                            )}
                          >
                            <div className="flex items-center gap-3 mb-[10px] cursor-pointer overflow-auto">
                              <img src={item?.icon} className="text-[#4A5661] w-[20px]" alt='icon' />
                              {item?.name}
                            </div>
                          </a>
                        )}
                      </MenuItem>
                    ))}

                  </div>
                </MenuItems>
              </Menu>
            </div>
          </div>
        </div>
        <hr className="md:mt-4" />
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-5">
          {filteredVideos.length > 0 ? (
            filteredVideos?.map((item, index) => (
              <div
                key={index}
                className="px-2 py-3 rounded bg-[#f3f3f3]"
                onClick={() => {
                  setSingleVideo(item);
                  setShowVideoPlayer(true);
                }}
              >
                <div className="relative flex justify-center items-center">
                  <img
                    src={youtube_play}
                    alt="youtube-play-button"
                    className="absolute w-12 h-12 "
                  />
                  <img
                    src={`${item?.thumbnail}`}
                    alt="video_img"
                    className="rounded-t-md w-52 h-48"
                  />
                </div>
                <p className="text-text_color text-[16px] font-medium mt-3 text-center">
                  {item?.heading}
                </p>
              </div>
            ))
          ) : (
            <div>No Videos Available</div>
          )}
        </div>
      </div>
      {showVideoPlayer && (
        <section className="fixed inset-0 z-[1000] grid place-items-center bg-[#000] bg-opacity-20 backdrop-blur-sm">
          <div className="relative w-full sm:w-[40%] md:w-[60%]">
            <div
              className="absolute right-2 top-2 p-2 w-8 h-8 rounded-full bg-[#a32c2c] text-white flex justify-center items-center cursor-pointer z-10"
              onClick={handleClose}
            >
              X
            </div>
            <iframe
              className="w-full h-[515px]"
              src={`https://www.youtube.com/embed/${getVideoId(singleVideo?.youtube_link)}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </section>
      )}
      {hasMore && filteredVideos.length ? (
        <div className="mt-5 flex justify-center">
          <button
            className="px-4 py-2 bg-primaryColor text-white rounded-lg"
            onClick={loadMoreVideos}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Load More"}
          </button>
        </div>
      ) : isLoading ? (
        <div className="mt-5 flex justify-center">
          <button
            className="px-4 py-2 bg-primaryColor text-white rounded-lg"
            disabled
          >
            Loading...
          </button>
        </div>
      ) : null}

    </>
  );
};

export default Video;
